import { GraphQLError } from "@urql/core/dist/urql-core-chunk";
import { Context } from "@/services/context.ts";

export const ALERTS_LISTENER_NAME = "alerts";

type Alert = {
  message: string;
  type: "danger" | "warning" | "success" | "neutral";
};

export class Alerts {
  public messages: Alert[] = [];

  constructor(protected context: Context) {}

  protected update = () => {
    this.context.notify(ALERTS_LISTENER_NAME);
  };

  removeMessage = (index: number) => {
    this.messages.splice(index, 1);
    this.update();
  };

  private get value() {
    return {
      ...this,
    };
  }

  addMessages(errors: string[], type: "danger" | "warning" | "success" | "neutral") {
    errors.forEach((error: string) => {
      this.messages.push({
        message: error,
        type,
      });
    });
    this.update();
  }
}
